// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3ZQwe","content":"LoadingAlert_content__16HHj"};